import React from "react";
import {
  ValimateExecutionStatus,
  ValimateTestCaseResultDto,
} from "../../autogenerated/models";
import { Collapse, Row, Tabs } from "antd";

import TucResult from "./TucResult";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { TestCaseRerun } from "../../store/slices/valimateSlice";

interface SessionRunResultProps {
  results: ValimateTestCaseResultDto[];
  sessionId: string;
  enableReruns: boolean;
  downloading: boolean;
  reruns: Array<TestCaseRerun>;
}

const SessionRunResult: React.FC<SessionRunResultProps> = ({
  results = [],
  sessionId = "",
  enableReruns = false,
  reruns = [],
  downloading = false,
}) => {
  const { Panel } = Collapse;
  const { TabPane } = Tabs;

  return (
    <>
      {results?.map((result: ValimateTestCaseResultDto, index) => {
        let status = ValimateExecutionStatus[ValimateExecutionStatus.Failed];
        if (
          result.testConfigurations
            ?.map((r) => r.execution?.status)
            .every((b) => b === ValimateExecutionStatus.Passed)
        ) {
          status = ValimateExecutionStatus[ValimateExecutionStatus.Passed];
        } else if (
          result.testConfigurations
            ?.map((r) => r.execution?.status)
            .some((b) => b === ValimateExecutionStatus.Inconclusive)
        ) {
          status =
            ValimateExecutionStatus[ValimateExecutionStatus.Inconclusive];
        } else if (
          result.testConfigurations
            ?.map((r) => r.execution?.status)
            .some(
              (b) =>
                b !== ValimateExecutionStatus.Inconclusive &&
                b !== ValimateExecutionStatus.Cancelled &&
                b !== ValimateExecutionStatus.Passed &&
                b !== ValimateExecutionStatus.Failed
            )
        ) {
          status = "Pending";
        }

        return (
          <Row key={`r-${index}`}>
            <Collapse style={{ width: "100%" }}>
              <Panel
                key={`p-${index}`}
                header={`${result.testCase?.identifier} - ${result.testCase?.name} - ${status}`}
                className="tucResultPanel"
              >
                <Tabs defaultActiveKey={`${result.testCase?.id}-c-0`}>
                  {result.testConfigurations?.map(
                    (configurationResult, confIndex) => {
                      let allPassed =
                        configurationResult.execution?.callback?.steps?.every(
                          (executionStep) => executionStep.result === "pass"
                        );
                      let anyFailed =
                        configurationResult.execution?.callback?.steps?.some(
                          (executionStep) => executionStep.result === "fail"
                        );

                      return (
                        <TabPane
                          tab={
                            <span
                              style={
                                allPassed
                                  ? { color: "#36842D" }
                                  : anyFailed
                                  ? { color: "#C4262E" }
                                  : {}
                              }
                            >
                              {configurationResult.testConfiguration?.name
                                ? configurationResult.testConfiguration?.name
                                : "Internal"}
                              {"  "}
                              {allPassed ? (
                                <CheckCircleOutlined />
                              ) : anyFailed ? (
                                <CloseCircleOutlined />
                              ) : (
                                ""
                              )}
                            </span>
                          }
                          key={`${result.testCase?.id}-c-${confIndex}`}
                        >
                          <TucResult
                            configurationResult={configurationResult}
                            result={result}
                            enableReruns={enableReruns}
                            reruns={reruns}
                            downloading={downloading}
                            sessionId={sessionId}
                            confIndex={confIndex}
                            index={index}
                          ></TucResult>
                        </TabPane>
                      );
                    }
                  )}
                </Tabs>
              </Panel>
            </Collapse>
          </Row>
        );
      })}
    </>
  );
};

export default SessionRunResult;
